<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <div class="font-20 font-300">Company Data</div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="submitForm">
              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="font-18 font-uppercase font-300">General Information</div>
                  <hr class="short-line left mt-5 mb-5">
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="company_name">Company Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="listData.company_name" id="company_name" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="email">Email</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="listData.company_email" id="email" type="email"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="company_phone">Company Phone</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input v-model="listData.company_phone" id="company_phone" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="map">MAP</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="map" v-model="listData.company_location" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="font-18 font-uppercase font-300 mt-30">Privacy Policy</div>
                  <hr class="short-line left mt-5 mb-5">
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Privacy Policy</label>
                </b-col>
                <b-col sm="10">
                  <quill-editor class="editor-custom" name="privacy_policy" ref="myTextEditor" v-model="listData.company_privacy_policy" :config="editorOption"></quill-editor>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="font-18 font-uppercase font-300 mt-30">Terms & Condition</div>
                  <hr class="short-line left mt-5 mb-5">
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Terms & Condition</label>
                </b-col>
                <b-col sm="10">
                  <quill-editor class="editor-custom" name="term_condition" ref="myTextEditor" v-model="listData.company_term_condition" :config="editorOption"></quill-editor>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="font-18 font-uppercase font-300 mt-30">Company Data</div>
                  <hr class="short-line left mt-5 mb-5">
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="company_our_story">Our Story</label>
                </b-col>
                <b-col sm="10">
                  <textarea class="w-100" rows="5" id="company_our_story" v-model="listData.company_our_story"></textarea>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="company_description">About Paradigm</label>
                </b-col>
                <b-col sm="10">
                  <textarea class="w-100" rows="5" id="company_description" v-model="listData.company_description"></textarea>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="company_values">Company Values</label>
                </b-col>
                <b-col sm="10">
                  <textarea class="w-100" rows="5" id="company_values" v-model="listData.company_values"></textarea>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="company_mission">Company Mission</label>
                </b-col>
                <b-col sm="10">
                  <textarea class="w-100" rows="5" id="company_mission" v-model="listData.company_mission"></textarea>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="company_vision">Company Vision</label>
                </b-col>
                <b-col sm="10">
                  <textarea class="w-100" rows="5" id="company_vision" v-model="listData.company_vision"></textarea>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="google_analytics_id">Google Analytics</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="google_analytics_id" v-model="listData.google_analytics_id" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="font-18 font-uppercase font-300 mt-30">Social Media Data</div>
                  <hr class="short-line left mt-5 mb-5">
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="facebook_link">Facebook Link</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="facebook_link" v-model="listData.facebook_link" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="twitter_link">Twitter Link</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="twitter_link" v-model="listData.twitter_link" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="instagram_link">Instagram Link</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="instagram_link" v-model="listData.instagram_link" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="youtube_link">Youtube Link</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="youtube_link" v-model="listData.youtube_link" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="font-18 font-uppercase font-300 mt-30">Email Configuration</div>
                  <hr class="short-line left mt-5 mb-5">
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="receiving_email">Receiving Email</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="receiving_email" v-model="listData.receiving_email" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="sender_name">Sender Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="sender_name" v-model="listData.sender_name" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="12">
                  <div class="font-18 font-uppercase font-300 mt-30">SMTP</div>
                  <hr class="short-line left mt-5 mb-5">
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="email_address">SMPTP Email Address</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="email_address" v-model="listData.email_address" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="smtp_hostname">SMPTP Hostname</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="smtp_hostname" v-model="listData.smtp_hostname" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="smtp_port">SMPTP Port</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="smtp_port" v-model="listData.smtp_port" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="smtp_username">SMPTP Username</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="smtp_username" v-model="listData.smtp_username" type="text"></b-form-input>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="smtp_password">SMPTP Password</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input id="smtp_password" v-model="listData.smtp_password" type="text"></b-form-input>
                </b-col>
              </b-row>
              <div class="text-right">
                <button type="submit" class="btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'siteConfiguration',
  data: function () {
    return {
      editorOption: {
        // modules: {
        //   toolbar: [
        //     ['bold', 'italic', 'underline', 'strike'],
        //     ['blockquote', 'code-block'],
        //     [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }],
        //   ]
        // }
      },
      apiGetData: '',
      listData: {
        company_name: '',
        company_email: '',
        company_phone: '',
        company_location: '',
        company_description: '',
        company_privacy_policy: '',
        company_term_condition: '',
        company_our_story: '',
        company_values: '',
        company_mission: '',
        company_vision: '',
        google_analytics_id: '',
        facebook_name: '',
        facebook_link: '',
        twitter_name: '',
        twitter_link: '',
        instagram_name: '',
        instagram_link: '',
        youtube_name: '',
        youtube_link: '',
        receiving_email: '',
        sender_name: '',
        email_address: '',
        smtp_hostname: '',
        smtp_port: '',
        smtp_username: '',
        smtp_password: ''
      }
    }
  },
  components: {
    quillEditor
  },
  methods: {
    submitForm () {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.put('compro/v1/configuration/1', this.listData).then(response => {
        // console.log('test', response.data.data.company_privacy_policy)
        this.$toast.success('data saved successfully!', 'Success', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
        // this.$router.go()
        // this.fetchData()
      }).catch(error => {
        console.log('error', error)
        this.$toast.success('cant saved data!', 'Error', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
      })
    },
    openPage (event) {
      this.$router.push(event)
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('compro/v1/configuration/1').then(response => {
        // console.log('test', response)
        // Object.keys(response.data.data[0]).forEach(function(key) {
        //   // this[key] = response.data.data[0][key]
        //   console.log(key, response.data.data[0][key])
        // })
        this.listData.company_name = response.data.data.company_name
        this.listData.company_email = response.data.data.company_email
        this.listData.company_phone = response.data.data.company_phone
        this.listData.company_description = response.data.data.company_description
        this.listData.company_location = response.data.data.company_location
        this.listData.company_privacy_policy = response.data.data.company_privacy_policy
        this.listData.company_term_condition = response.data.data.company_term_condition
        this.listData.company_our_story = response.data.data.company_our_story
        this.listData.company_values = response.data.data.company_values
        this.listData.company_mission = response.data.data.company_mission
        this.listData.company_vision = response.data.data.company_vision
        this.listData.google_analytics_id = response.data.data.google_analytics_id
        this.listData.facebook_name = response.data.data.facebook_name
        this.listData.facebook_link = response.data.data.facebook_link
        this.listData.twitter_name = response.data.data.twitter_name
        this.listData.twitter_link = response.data.data.twitter_link
        this.listData.instagram_name = response.data.data.instagram_name
        this.listData.instagram_link = response.data.data.instagram_link
        this.listData.youtube_name = response.data.data.youtube_name
        this.listData.youtube_link = response.data.data.youtube_link
        this.listData.receiving_email = response.data.data.receiving_email
        this.listData.sender_name = response.data.data.sender_name
        this.listData.email_address = response.data.data.email_address
        this.listData.smtp_hostname = response.data.data.smtp_hostname
        this.listData.smtp_port = response.data.data.smtp_port
        this.listData.smtp_username = response.data.data.smtp_username
        this.listData.smtp_password = response.data.data.smtp_password
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
  }
}
</script>

<style>
</style>
